import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { SharedModule } from '../shared/shared.module';

import { KioskFooterComponent } from './kiosk-footer/kiosk-footer.component';
import { KioskHomeComponent } from './kiosk-home/kiosk-home.component';
import { KioskAppointmentsComponent } from './kiosk-appointments/kiosk-appointments.component';
import { KioskUserLoginComponent } from './kiosk-user-login/kiosk-user-login.component';
import { KioskInformationsComponent } from './kiosk-informations/kiosk-informations.component';
import { KioskErrorComponent } from './kiosk-error/kiosk-error.component';
import { KioskPatientCardComponent } from './kiosk-patient-card/kiosk-patient-card.component';

import { KioskService } from './kiosk.service';
import { KioskEffects } from './kiosk.effects';
import { KioskInterceptor } from './kiosk.interceptor';

const providers: any[] = [
  { 
    provide: HTTP_INTERCEPTORS,
    useClass: KioskInterceptor, 
    multi: true,
  },
  KioskService,
];

@NgModule({
  declarations: [
    KioskFooterComponent,
    KioskHomeComponent,
    KioskAppointmentsComponent,
    KioskUserLoginComponent,
    KioskErrorComponent,
    KioskInformationsComponent,
    KioskPatientCardComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.run(KioskEffects),
  ],
  providers,
  exports: [],
  entryComponents: [
    KioskFooterComponent,
    KioskHomeComponent,
    KioskAppointmentsComponent,
    KioskErrorComponent,
    KioskInformationsComponent,
    KioskPatientCardComponent,
  ],
})

export class KioskModule {}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk.module.ts